import React from 'react'
import PropTypes from 'prop-types'
import ResponsiveModal from 'react-responsive-modal'
import styles from './Modal.scss'

function Modal({ isOpen, close, children, modalRef }) {
  return (
    <ResponsiveModal
      ref={modalRef}
      open={isOpen}
      onClose={close}
      center
      closeIconSize={22}
      classNames={{
        modal: styles.modal,
        closeButton: styles.close,
        overlay: styles.overlay,
      }}
    >
      {children}
    </ResponsiveModal>
  )
}

Modal.propTypes = {
  modalRef: PropTypes.object,
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  children: PropTypes.node,
}

export default Modal
